import React from "react";
import { Box, BoxProps } from "@amzn/awsui-components-react/polaris";

import { ColorBand, colorBandFor } from "./colorBandFor";
import { parseValidationStatus } from "./parseValidationStatus";

const BOX_COLOR: Readonly<Record<ColorBand, BoxProps.Color>> = {
  red: "text-status-error",
  orange: "text-status-warning",
  green: "text-status-success",
};

export interface ValidationStatusCellProps {
  readonly value: string | null | undefined;
}

export const ValidationStatusCell: React.FC<ValidationStatusCellProps> = ({
  value,
}) => {
  const ratio = parseValidationStatus(value);

  if (ratio === undefined) {
    return <>-</>;
  }

  const { passed, total } = ratio;
  const band = colorBandFor(passed / total);

  return (
    <Box color={BOX_COLOR[band]}>
      {passed} / {total}
    </Box>
  );
};

export default ValidationStatusCell;
